import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowUpRight } from 'lucide-react';

const Projects = () => {
  const projects = [
    {
      image: 'https://res.cloudinary.com/dwbfrbwul/image/upload/f_auto,q_auto/v1765090622/hillpoint/projects/hillpoint/projects/corporate/hillpoint-corporate-accenture-office-acoustics.jpg',
      title: 'Corporate Spaces',
      category: 'Corporate',
      link: '/projects/gallery?category=corporate'
    },
    {
      image: 'https://res.cloudinary.com/dwbfrbwul/image/upload/f_auto,q_auto/v1765090672/hillpoint/projects/hillpoint/projects/education/hillpoint-education-al-nahda-school-abu-dhabi.jpg',
      title: 'Educational Facilities',
      category: 'Education',
      link: '/projects/gallery?category=education'
    },
    {
      image: 'https://res.cloudinary.com/dwbfrbwul/image/upload/f_auto,q_auto/v1765090730/hillpoint/projects/hillpoint/projects/hospitality/hillpoint-hospitality-hotel-acoustics.jpg',
      title: 'Hospitality',
      category: 'Hospitality',
      link: '/projects/gallery?category=hospitality'
    },
  ];

  return (
    <section id="projects" className="relative py-16 md:py-24 bg-hillpoint overflow-hidden text-white">
      {/* Grain Texture */}
      <div className="absolute inset-0 opacity-20 pointer-events-none mix-blend-overlay z-10"
           style={{ filter: 'url(#grain)' }}></div>

      {/* Animated Gradient Blobs */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-hillpoint-lighter rounded-full blur-[120px] opacity-20 animate-pulse"></div>
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-gold rounded-full blur-[150px] opacity-10 animate-pulse delay-1000"></div>

      <div className="max-w-[1600px] mx-auto px-5 md:px-8 relative z-20">
        
        {/* Maximalist Header - CENTERED & RESPONSIVE */}
        <div className="mb-12 md:mb-16 text-center">
             <h2 className="font-serif font-bold text-white leading-none tracking-tighter mb-4">
                <span className="block text-[clamp(2.5rem,7vw,8rem)]">
                    Acoustic <span className="text-transparent [-webkit-text-stroke:2px_#D4AF37]">Excellence</span> <span className="italic text-gold">Worldwide</span>
                </span>
            </h2>
            <p className="text-base md:text-xl text-stone-300 font-light leading-relaxed max-w-3xl mx-auto">
                <span className="text-white font-bold">500+ projects</span> across corporate, education, and hospitality spaces. The photos tell you more than we can.
            </p>
        </div>

        {/* Project Showcase - Magazine Style Layout (TIGHTER SPACING) */}
        <div className="space-y-0 border-t border-white/10">
          {projects.map((project, index) => (
            <Link
              key={index}
              to={project.link}
              className="group relative block w-full border-b border-white/10 hover:border-gold/50 transition-colors duration-500"
            >
              <div className="flex flex-col md:flex-row items-center py-8 md:py-12 px-4 md:px-0">
                  
                  {/* Index Number */}
                  <div className="w-24 hidden md:block text-stone-500 font-serif text-xl italic">
                      0{index + 1}
                  </div>

                  {/* Title Section */}
                  <div className="flex-1 z-20 w-full text-center md:text-left">
                      <div className="flex flex-col md:flex-row items-center md:items-baseline gap-2 md:gap-4">
                          <h3 className="text-3xl md:text-6xl font-serif font-bold text-white group-hover:text-gold transition-colors duration-500">
                              {project.title}
                          </h3>
                          <span className="text-xs font-bold uppercase tracking-widest text-white bg-hillpoint/90 border border-white/30 px-2 py-1 rounded-full">
                              {project.category}
                          </span>
                      </div>
                  </div>

                  {/* Hover Reveal Image - Responsive to row height */}
                  <div className="hidden md:block w-[280px] absolute right-24 top-2 bottom-2 opacity-0 group-hover:opacity-100 translate-x-10 group-hover:translate-x-0 transition-all duration-700 ease-out overflow-hidden pointer-events-none z-10 rounded-sm">
                      <div className="absolute inset-0 bg-gold/20 mix-blend-overlay z-10"></div>
                      <img 
                        src={project.image} 
                        alt={project.title} 
                        className="w-full h-full object-cover scale-110 group-hover:scale-100 transition-transform duration-1000"
                        width={400}
                        height={300}
                      />
                  </div>

                  {/* Arrow */}
                  <div className="w-full md:w-24 flex justify-center md:justify-end mt-6 md:mt-0">
                      <div className="w-12 h-12 md:w-16 md:h-16 rounded-full border border-white/20 group-hover:bg-gold group-hover:border-gold flex items-center justify-center transition-all duration-500">
                          <ArrowUpRight className="w-5 h-5 md:w-6 md:h-6 text-white group-hover:text-hillpoint" />
                      </div>
                  </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12 md:mt-16">
           <Link to="/projects/gallery">
            <Button className="bg-hillpoint/95 border border-gold text-gold hover:bg-gold hover:text-hillpoint px-10 py-6 md:px-16 md:py-8 text-lg md:text-xl rounded-none tracking-[0.2em] uppercase transition-all duration-500">
              View All Projects
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Projects;
